import { z } from 'zod';
import { isCuitValid } from '@/utils/cuit-utils';

enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export const registerSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: 'El nombre completo es requerido' })
      .max(100, { message: 'El nombre es demasiado largo' }),
    email: z
      .string()
      .min(1, { message: 'El correo electrónico es requerido' })
      .email({ message: 'Ingresa un correo electrónico válido' })
      .max(255, { message: 'El correo electrónico es demasiado largo' }),
    password: z
      .string()
      .min(6, { message: 'La contraseña debe tener al menos 6 caracteres' })
      .max(100, {
        message: 'La contraseña no puede tener más de 100 caracteres',
      }),
    confirmPassword: z
      .string()
      .min(1, { message: 'Debe confirmar la contraseña' }),
    birthdate: z
      .string()
      .min(1, { message: 'La fecha de nacimiento es requerida' })
      .refine(
        (date) => {
          const birthdateObj = new Date(date);
          const today = new Date();
          const age = today.getFullYear() - birthdateObj.getFullYear();
          return age >= 18;
        },
        { message: 'Debes ser mayor de 18 años para registrarte' },
      ),
    gender: z.nativeEnum(Gender, {
      message: 'Selecciona un género válido',
    }),
    id: z
      .string()
      .min(11, { message: 'El CUIT debe tener exactamente 11 dígitos' })
      .max(11, { message: 'El CUIT debe tener exactamente 11 dígitos' })
      .regex(/^\d{11}$/, { message: 'El CUIT debe contener solo números' })
      .refine((cuit) => isCuitValid(cuit), {
        message: 'El CUIT ingresado no es válido',
      }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export type RegisterFormData = z.infer<typeof registerSchema>;

export type ManagerRegistrationPayload = {
  name: string;
  email: string;
  password: string;
  birthdate: string; // ISO string
  gender: string;
  id: string; // CUIT (Tax ID)
};

export { Gender };
